export default {
  install(Vue) {
    Vue.prototype.$_ = _;
  },
};
